import {Node, NodeMap} from "./node";

export enum BlockType {
  TEXT = 'text',
  RICH_TEXT = 'rich_text',
  HEADING_1 = 'heading_1',
  HEADING_2 = 'heading_2',
  HEADING_3 = 'heading_3',
  BULLETED_LIST_ITEM = 'bulleted_list_item',
  NUMBERED_LIST_ITEM = 'numbered_list_item',
  TO_DO = 'to_do',
  TO_DO_ITEM = 'to_do_item',
  TOGGLE = 'toggle',
  TOGGLE_ITEM = 'toggle_item',
  CHILD_PAGE = 'child_page',
  UNSUPPORTED = 'unsupported',
  PARAGRAPH = 'paragraph',
  CALLOUT = 'callout',
  QUOTE = 'quote',
}

export type Block = {
  [key in keyof BlockType]: NodeMap;
} & {
  created_time: string;
  has_children: boolean;
  id: string;
  last_edited_time: string;
  object: 'block';
  type: BlockType;
  children?: Node[];
};
